import Lottie from "lottie-react"
import HandLoader from "./HandLoader.json"
export const SignInLoader = () => {
 return (
  <div className="absolute z-30 inset-0 backdrop-blur">
   <div className="flex w-full h-full justify-center items-center">
    <Lottie animationData={HandLoader} loop={true} />;
   </div>
  </div>
 )
}
